import { useDebitNoteResponseQuery } from '@/app/services/debitNoteApi';
import { usePeriod } from '@/components/context/PeriodContext';
import PeriodDetails from '@/components/periodDetails/PeriodDetails';
import SearchDebitNotes from '@/components/searchBar/SearchDebitNotes';
import DebitNoteTable from '@/components/tables/DebitNotesTable';
import { Box, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function DebitNote() {
  const { t } = useTranslation(['debitNote', 'common']);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(5);
  const [searchTerm, setSearchTerm] = useState('');

  const { selectedPeriod } = usePeriod();

  const { data } = useDebitNoteResponseQuery(
    {
      searchTerm: searchTerm.toUpperCase() as string,
      periodDate: selectedPeriod?.date as string,
      page,
      size,
    },
    { skip: !selectedPeriod },
  );

  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        marginRight: '20px',
        justifyContent: 'space-between',
      }}
    >
      <PeriodDetails />
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        <Box sx={{ width: '100%' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <Typography
              sx={{
                fontWeight: 'bold',
                fontSize: '20px',
                color: '#4b4b4b',
                marginTop: '32px',
              }}
            >
              {t('Histórico Notas de Débito')}
            </Typography>
          </Box>
        </Box>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '2.5rem',
          width: '70%',
          marginBottom: '15px',
        }}
      >
        <SearchDebitNotes searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
        }}
      >
        <DebitNoteTable
          rows={data?.content || []}
          count={data?.totalElements as number}
          page={page}
          setPage={setPage}
          rowsPerPage={size}
          setRowsPerPage={setSize}
        />
      </div>
    </div>
  );
}
export default DebitNote;
